/**
 * Created by slava on 02.02.17.
 */

const IceTileView = cc.Node.extend({
    ...BaseTileView,
    ctor: function (tile) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.initialize(tile);

        const bundle = tile.bundleId();
        if (tile.x < 0) {
            this.image = new cc.Sprite(bundles[bundle].frames[`${bundle}_goal`]);
            this.image.setScaleX(cleverapps.styles.IceTileView.goal.scaleX);
        } else {
            this.image = new cc.Sprite(bundles[bundle].frames[`${bundle}_tile`]);
            this.setLocalZOrder(3);
        }

        this.image.setPosition(this.width / 2, this.height / 2);
        this.addChild(this.image);

        this.tile.onCreateNew = this.animateCreateNew.bind(this);
    },

    initialize: function (tile) {
        if (this.image) {
            this.image.setScale(1);
        }
        BaseTileView.initialize.call(this, tile);
    },

    startExploding: function () {
        this.stopAllActions();
        if (!Game.currentGame.goals.hasType(this.tile.getGoalId())) {
            this.image.runAction(new cc.Sequence(
                new cc.ScaleTo(0.3, 0).easing(cc.easeBackIn()),
                new cc.CallFunc(() => {
                    this.delete();
                })
            ));
            return;
        }
        const fieldView = Game.currentGame.field.onGetView();
        const collectAnimation = BaseAnimation.factoryLimited(bundles[this.tile.bundleId()].jsons.ice_spine_json);
        const pos = this.getPosition();
        const object = this.tile;
        collectAnimation.setPosition(pos);
        fieldView.addChild(collectAnimation);

        Game.currentGame.goalCounter.setTimeout(() => {
        }, 700);

        let id = 0;
        if (IceTileView.lastExplodeTime > Date.now() - 100) {
            id = IceTileView.groupSize;
        } else {
            IceTileView.groupSize = 0;
            IceTileView.lastExplodeTime = Date.now();
        }
        IceTileView.groupSize++;
        const groupSize = IceTileView.groupSize;

        const styles = cleverapps.styles.IceTileView;
        if (styles.collectAnimation && this.onCollectAnimation) {
            this.onCollectAnimation(object, id, groupSize);
        }

        const bundle = this.tile.bundleId();
        collectAnimation.runAnimate("two", styles.collectAnimation ? undefined : () => {
            if (Game.currentGame) {
                const icon = new cc.Sprite(bundles[bundle].frames.ice_goal);
                icon.setLocalZOrder(5);
                icon.setPosition(pos.x + cleverapps.styles.IceTileView.potMargin.x, pos.y + cleverapps.styles.IceTileView.potMargin.y);
                fieldView.addChild(icon);

                const goal = Game.currentGame.goals.findTargetFor(object.getGoalId());
                goal.collect(1, icon);
            }
        }, new cc.Sequence(new cc.CallFunc((object) => {
            object.setScale(0.1);
        }), new cc.Spawn(new cc.MoveBy(0.3, cleverapps.styles.IceTileView.potMargin.x, cleverapps.styles.IceTileView.potMargin.y), new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut()))));

        this.delete();
    },

    animateCreateNew: function () {
        this.image.setScale(0);
        this.image.runAction(
            new cc.Sequence(
                new cc.ScaleTo(0.1, 0.25).easing(cc.easeBackOut()),
                new cc.ScaleTo(0.1, 0.15).easing(cc.easeBackOut()),
                new cc.ScaleTo(0.3, 1.05).easing(cc.easeBackOut()),
                new cc.ScaleTo(0.1, 1).easing(cc.easeBackOut())
            )
        );
    } 
});

IceTileView.lastExplodeTime = 0;
IceTileView.groupSize = 0;

cleverapps.styles.IceTileView = {
    potMargin: {
        x: -53,
        y: -32
    },
    goal: {
        scaleX: -1
    }
};
